{
  "name": "acs_front",
  "version": "2.0.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:prod": "ng build",
    "build:preprod": "ng build --configuration=preprod",
    "build:beta": "ng build --configuration=beta",
    "build:alpha": "ng build --configuration=alpha",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "lint": "ng lint",
    "swagger:generate": "$env:NODE_TLS_REJECT_UNAUTHORIZED=0; npx ng-openapi-gen --input https://acs-proxy-alpha.courtage.dev.ecilia.fr/doc/acs.json --output src/app/core/api",
    "post-ng-openapi-gen": "node replace-api-url.js",
    "e2e": "cypress open"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^18.0.6",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/material": "^18.1.1",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "bulma": "^1.0.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.2",
    "flag-icons": "^7.5.0",
    "i18n-iso-countries": "^7.14.0",
    "jsonc-parser": "^3.3.1",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.12.25",
    "ng-openapi-gen": "^0.51.0",
    "ngx-mat-input-tel": "^20.4.0",
    "prettier-eslint": "^16.2.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular-eslint/builder": "18.0.1",
    "@angular-eslint/eslint-plugin": "18.0.1",
    "@angular-eslint/eslint-plugin-template": "18.0.1",
    "@angular-eslint/schematics": "18.0.1",
    "@angular-eslint/template-parser": "18.0.1",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/jest": "^29.5.14",
    "@typescript-eslint/eslint-plugin": "6.13.1",
    "@typescript-eslint/parser": "6.13.1",
    "cypress": "^15.5.0",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-preset-angular": "^14.0.0",
    "prettier": "3.2.5",
    "typescript": "~5.8.3"
  }
}
